import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $cardVerifications,
  $totalCountOfCardVerifications,
  cardVerificationsListMounted,
  getCardVerifications,
} from './model'
import { CardVerificationRequest } from './types'

export const useCardVerificationsList = () => {
  const onChangeCardVerificationsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    searchedColumn,
    filters,
  }: CardVerificationRequest) => {
    cardVerificationsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      searchedColumn,
      filters,
    })
  }

  const cardVerifications = useStore($cardVerifications)
  const totalCountOfCardVerifications = useStore($totalCountOfCardVerifications)
  const loading = useStore(getCardVerifications.pending)
  return {
    cardVerifications,
    totalCountOfCardVerifications,
    loading,
    onChangeCardVerificationsList,
  }
}
